import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Container, Col, Row } from 'reactstrap';
// import PropTypes from 'prop-types';


import getCodeDefinitions from '../../../graphql/codeDefinitions';
import Codes from '../../../config/codeDefinitions.json';
import './CodeDefinitions.scss';
import CodeDefinitionBlock from './CodeDefinitionBlock';

export default class CodeDefinitions extends Component {
  static propTypes = {
  };

  static defaultProps = {
  };

  static initialState = {
    isLoading: true,
    qup: [],
    ui: [],
  };
  state = CodeDefinitions.initialState;

  componentDidMount() {
    this.retrieveCodeDefinitions("UI", "ui");
    this.retrieveCodeDefinitions("QUP", "qup");
  }

  retrieveCodeDefinitions = async (codeName, codeList) => {
    const res = await getCodeDefinitions(codeName);
    this.setState({ [codeList]: res });
  }



  render() {
    const keys = Object.keys(Codes);
    const fields = keys.map(key => ({ codeValue: key, codeDefinition: Codes[key] }));
    return (
      <Container xs="auto">
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Code Definitions Help Page</title>
          <meta name="description" content="Acquisition Method Code (AMC) & Acquisition Method Suffix Code (AMSC) definitions" />
          <meta name="keywords" content="AMC, AMSC, AMC/AMSC" />
        </Helmet>
        <br />
        <Row>
          <h2>Code Definitions</h2>
        </Row>
        <Col xs="auto" className="nffs-code-definitions-container">
          <CodeDefinitionBlock
            columnsLayout={2}
            data={fields.slice(0, 5)}
            cardHeader="AMC Codes"
            cardId="amcCodes"
          />
          <CodeDefinitionBlock
            columnsLayout={2}
            data={fields.slice(5)}
            cardHeader="AMSC Codes"
            cardId="amscCodes"
          />
          {this.state.qup.length > 0 &&
            <CodeDefinitionBlock
              columnsLayout={2}
              data={this.state.qup}
              cardHeader="QUP Codes"
              cardId="qupCodes"
            />

          }
          {this.state.ui.length > 0 &&
            <CodeDefinitionBlock
              columnsLayout={3}
              data={this.state.ui}
              cardHeader="UI Codes"
              cardId="uiCodes"
            />
          }

          {/* <Row>
          <h4>AMC Codes</h4>
          <table>
            <th>Code</th>
            <th>Definition</th>
            {fields.slice(0, 5).map(elm => (
              <tr>
                <td>{elm.codeValue} </td>
                <td>{elm.codeDefinition} </td>
              </tr>
            ))}
          </table>
        </Row>
        <br />
        <Row>
          <h4>AMSC Codes</h4>
          <table>
            <th>Code</th>
            <th>Definition</th>
            {fields.slice(5).map(elm => (
              <tr>
                <td>{elm.codeValue}</td>
                <td>{elm.codeDefinition}</td>
              </tr>
            ))}
          </table>
        </Row> */}

        </Col>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/static/CodeDefinitions/CodeDefinitions.jsx